const data = {
  industriesEl: '#industries-data',
  categoryEl: '#category-data',
  industryEl: '#industry-data',
  brandsEl: '#brands-data',
  brandEl: '#brand-data'
}

export { data }
